<template>
	<section>
		<div class="partners-filter-item">
			<img
				:src="brandingPartners.partnerImage.imageUri"
				:alt="brandingPartners.name"
			/>
			<div class="partners-filter-item--information">
				<span class="partners-filter-item--name">{{
					brandingPartners.name
				}}</span>
				<span class="partners-filter-item--title">{{
					brandingPartners.partnerTitle
				}}</span>
			</div>
			<div class="partners-filter-item-btn--wrapper">
				<button
					type="button"
					:id="`delete-partner-${brandingPartners.index}`"
					:aria-label="`delete ${brandingPartners.name}'s information`"
					class="b360-btn--delete"
					@click="modalBuilder('delete')"
				>
					<font-awesome-icon :icon="['far', 'trash-alt']" />
				</button>
				<button
					type="button"
					class="partners-filter-item--edit-btn"
					:aria-label="`edit ${brandingPartners.name}'s information`"
					@click="modalBuilder('save')"
				>
					<font-awesome-icon class :icon="['far', 'cog']" />
				</button>
			</div>
		</div>
		<PartnerModalWrapper
			v-if="showModal"
			:show="showModal"
			@close="showModal = false"
			:modalTitle="modalType === 'delete' ? 'Delete Partner' : 'Edit Partner'"
			:actionBtnName="modalType"
			:deleteBtn="false"
			@modal-action="managePartnerAction"
		>
			<partners-delete-item
				v-if="modalType === 'delete'"
				slot="modalContent"
				:partnerName="brandingPartners.name"
			></partners-delete-item>
			<partners-modal
				v-if="modalType === 'save'"
				slot="modalContent"
				:partner="brandingPartners"
			></partners-modal>
		</PartnerModalWrapper>
	</section>
</template>

<script>
import PartnersDeleteItem from '@/components/preference-center/PartnersDeleteItem.vue';
import PartnerModalWrapper from '@/components/preference-center/PartnerModalWrapper.vue';
import PartnersModal from '@/components/preference-center/PartnersModal.vue';
import { mapActions, mapState } from 'vuex';
import profileApiClient from '@/services/profile/profile-service';

export default {
	name: 'PartnersFilterItem',
	components: {
		PartnersModal,
		PartnersDeleteItem,
		PartnerModalWrapper,
	},
	props: {
		brandingPartners: Object,
	},
	data() {
		return {
			showModal: false,
			modalType: null,
		};
	},
	computed: {
		...mapState({
			contactId: (state) => state.profile.contactId,
			partner: (state) => state.partners.newPartner,
		}),
	},
	methods: {
		...mapActions(['updatePartner', 'deletePartner', 'savePartner']),
		modalBuilder(type) {
			this.updatePartner(this.brandingPartners);
			this.showModal = true;
			this.modalType = type;
		},
		managePartnerAction(actionType) {
			if (actionType === 'delete') {
				this.deletePartner(this.brandingPartners);
			} else {
				profileApiClient.savePartners(this.contactId, this.partner);
				this.savePartner(this.partner);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.partners-filter-item {
	display: flex;
	@include rem(padding-bottom, 20px);
	border-bottom: $b360-border-width-thin solid $border-color-light;
	align-items: flex-start;
	@include rem(margin-bottom, 20px);

	img {
		border-radius: $b360-border-radius-base;
		width: 44px;
		height: 44px;
		@include rem(margin-right, 15px);
	}

	&--information {
		display: inline-flex;
		flex-direction: column;
	}

	&--name {
		@include typo--roboto__medium;
		@include rem(font-size, 16px);
		color: $subheader-color;
		line-height: 1.5;
		@include rem(padding-right, 15px);
	}

	&--title {
		@include typo--roboto__regular;
		@include rem(font-size, 15px);
		color: $text-base-color;
		line-height: 1.4;
		@include rem(padding-right, 15px);
	}

	&--edit-btn {
		display: inline-flex;
		width: 44px;
		height: 44px;
		color: $brand-blue;
		@include rem(font-size, 22px);
		border-radius: $b360-border-radius-base;
		box-shadow: inset 0 0 0 1px $border-color-light;
		align-items: center;
		justify-content: center;
		border: none;
		background-color: $white;
		@include rem(margin-left, 10px);
		cursor: pointer;

		&:hover,
		&:focus {
			background-color: $brand-blue;
			color: $white;
			box-shadow: unset;
		}
	}

	&-btn--wrapper {
		margin-left: auto;
		display: flex;
	}
}
</style>
